export default "__VITE_ASSET__H9GxVT$J__"